import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BiChevronLeft } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';

import { useGetPayoutFetchQuery } from '@/app/services/package-rtk.service';
import LoadingComponent from '@/components/common/loading/loading.component';
import { PSButton } from '@/components/ui/button';
import { WrappedErrorBoundary } from '@/pages/WrappedErrorBoundary';

import Payout from './components/Payout';
import PayoutRequest from './components/PayoutRequest';

const MarketPlacePayment = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { isLoading, data } = useGetPayoutFetchQuery();

  const tabs = [<PayoutRequest profile={data} key={0} />, <Payout profile={data} key={1} />];

  const [activeComponentIndex, setActiveComponentIndex] = useState(0);

  const handleClick = (index: number) => {
    setActiveComponentIndex(index);
  };

  if (isLoading) {
    return <LoadingComponent />;
  }

  return (
    <React.Fragment>
      <PSButton
        id="btn-payment-back"
        variant="none"
        type="button"
        icon={<BiChevronLeft size={24} />}
        onClick={() => navigate(-1)}
        className="tw-flex tw-items-center tw-gap-1 tw-border-none tw-bg-transparent tw-text-gray-700 hover:tw-text-gray-900 tw-pl-3"
        title={t('Wizard/general/key6')}
      />
      <div className="tw-flex tw-flex-col lg:tw-p-5 tw-gap-5 !tw-pt-0 tw-px-3 md:tw-px-0">
        <div className="tw-flex tw-mt-5 tw-gap-x-5">
          <button
            id="btn-active-history"
            onClick={() => handleClick(0)}
            className={`tw-relative cursor-pointer ${
              activeComponentIndex == 0 ? 'tw-text-blue-500' : 'tw-text-gray-500'
            } tw-border-none tw-bg-transparent tw-text-sm tw-font-medium tw-font-['Lexend'] tw-leading-tight`}
          >
            {t('marketplace/payment/history')}
            {activeComponentIndex === 0 && <div className="tw-absolute tw-w-[40px] tw-top-[38px]  tw-border-[1px] tw-border-blue-500 tw-border-solid"></div>}
          </button>
          <button
            id="btn-active-payout"
            onClick={() => handleClick(1)}
            className={`tw-relative cursor-pointer ${
              activeComponentIndex == 1 ? 'tw-text-blue-500' : 'tw-text-gray-500'
            } tw-border-none tw-bg-transparent tw-text-sm tw-font-medium tw-font-['Lexend'] tw-leading-tight`}
          >
            {t('BusinessPartner/t-04')}
            {activeComponentIndex === 1 && <div className="tw-absolute tw-w-[40px] tw-top-[38px]  tw-border-[1px] tw-border-blue-500 tw-border-solid"></div>}
          </button>
        </div>
        <div className="tw-w-full">
          <div className="tw-w-full tw-border-solid tw-border-gray-300 tw-h-[1px] tw-border-t-[1px] tw-border-b-0 "></div>
        </div>
        {tabs[activeComponentIndex]}
      </div>
    </React.Fragment>
  );
};

export default WrappedErrorBoundary(MarketPlacePayment);
